import Loadable from '../../components/loadable';

const AllAttendancesReport = Loadable({
  loader: () => import('../../pages/reports/all_attendances_report/all_attendances_report'),
});

angular.module('gym').value('AllAttendancesReport', AllAttendancesReport);

const AllAttendancesReportFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/all_attendances_report/all_attendances_report_filters_modal'),
});

angular.module('gym').value('AllAttendancesReportFiltersModal', AllAttendancesReportFiltersModal);
